import { useNavigate } from 'react-router-dom'
import { chatSideBarAction } from '@/store/chatSideBar'
import type { NewAgentItemProp } from '@/store/chatSideBar'

export const useJumpChat = () => {
  const navigate = useNavigate()

  const jumpToChat = (item: NewAgentItemProp) => {
    if (item.id != null && item.id.length <= 0) {
      item.url && window.open(item.url, '_blank')
      return
    }
    // 重置并设置对话数据
    chatSideBarAction.jumpChatResetData(item)
    // 跳转到对话页面
    navigate('/chat')
  }

  return {
    jumpToChat,
  }
}
